import { render, staticRenderFns } from "./ErrorcodeDetail.vue?vue&type=template&id=35cc37b4&scoped=true&"
import script from "./ErrorcodeDetail.vue?vue&type=script&lang=js&"
export * from "./ErrorcodeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cc37b4",
  null
  
)

export default component.exports